module.exports = __webpack_public_path__ + "img/cover-post-img.810849ff.jpg";